webpackJsonp([107818501498521],{

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: theme.spacing.unit * 5,
	      height: theme.spacing.unit * 5,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE11.
	      objectFit: 'cover'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Avatar(props) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      childrenClassNameProp = props.childrenClassName,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "childrenClassName", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet"]);
	  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
	  var children = null;
	
	  if (childrenProp) {
	    if (childrenClassNameProp && typeof childrenProp !== 'string' && _react.default.isValidElement(childrenProp)) {
	      var childrenClassName = (0, _classnames.default)(childrenClassNameProp, childrenProp.props.className);
	      children = _react.default.cloneElement(childrenProp, {
	        className: childrenClassName
	      });
	    } else {
	      children = childrenProp;
	    }
	  } else if (src || srcSet) {
	    children = _react.default.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other), children);
	}
	
	Avatar.propTypes =  false ? {
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar.
	   * `src` and `alt` props will not be used and no `img` will
	   * be rendered by default.
	   *
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * The className of the child element.
	   * Used by Chip and ListItemIcon to style the Avatar icon.
	   */
	  childrenClassName: _propTypes.default.string,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Attributes applied to the `img` element when the component
	   * is used to display an image.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   */
	  srcSet: _propTypes.default.string
	} : {};
	Avatar.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(27));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _keycode = _interopRequireDefault(__webpack_require__(53));
	
	var _Cancel = _interopRequireDefault(__webpack_require__(128));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var _colorManipulator = __webpack_require__(94);
	
	__webpack_require__(122);
	
	// So we don't have any override priority issue.
	var styles = function styles(theme) {
	  var height = 32;
	  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
	  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
	  return {
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(13),
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: height,
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      borderRadius: height / 2,
	      whiteSpace: 'nowrap',
	      transition: theme.transitions.create(['background-color', 'box-shadow']),
	      // label will inherit this from root, then `clickable` class overrides this for both
	      cursor: 'default',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 'none',
	      textDecoration: 'none',
	      border: 'none',
	      // Remove `button` border
	      padding: 0 // Remove `button` padding
	
	    },
	    clickable: {
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      },
	      '&:active': {
	        boxShadow: theme.shadows[1],
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.12)
	      }
	    },
	    deletable: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      }
	    },
	    avatar: {
	      marginRight: -4,
	      width: height,
	      height: height,
	      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	      fontSize: theme.typography.pxToRem(16)
	    },
	    avatarChildren: {
	      width: 19,
	      height: 19
	    },
	    label: {
	      display: 'flex',
	      alignItems: 'center',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap',
	      cursor: 'inherit'
	    },
	    deleteIcon: {
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      color: deleteIconColor,
	      cursor: 'pointer',
	      height: 'auto',
	      margin: '0 4px 0 -8px',
	      '&:hover': {
	        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
	      }
	    }
	  };
	};
	/**
	 * Chips represent complex entities in small blocks, such as a contact.
	 */
	
	
	exports.styles = styles;
	
	var Chip =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Chip, _React$Component);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Chip);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Chip.__proto__ || Object.getPrototypeOf(Chip)).call.apply(_ref, [this].concat(args))), _this.chipRef = null, _this.handleDeleteIconClick = function (event) {
	      // Stop the event from bubbling up to the `Chip`
	      event.stopPropagation();
	      var onDelete = _this.props.onDelete;
	
	      if (onDelete) {
	        onDelete(event);
	      }
	    }, _this.handleKeyDown = function (event) {
	      // Ignore events from children of `Chip`.
	      if (event.currentTarget !== event.target) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onDelete = _this$props.onDelete,
	          onKeyDown = _this$props.onKeyDown;
	      var key = (0, _keycode.default)(event);
	
	      if (onClick && (key === 'space' || key === 'enter')) {
	        event.preventDefault();
	        onClick(event);
	      } else if (onDelete && key === 'backspace') {
	        event.preventDefault();
	        onDelete(event);
	      } else if (key === 'esc') {
	        event.preventDefault();
	
	        if (_this.chipRef) {
	          _this.chipRef.blur();
	        }
	      }
	
	      if (onKeyDown) {
	        onKeyDown(event);
	      }
	    }, _temp));
	  }
	
	  (0, _createClass2.default)(Chip, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          avatarProp = _props.avatar,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          clickable = _props.clickable,
	          Component = _props.component,
	          deleteIconProp = _props.deleteIcon,
	          label = _props.label,
	          onClick = _props.onClick,
	          onDelete = _props.onDelete,
	          onKeyDown = _props.onKeyDown,
	          tabIndexProp = _props.tabIndex,
	          other = (0, _objectWithoutProperties2.default)(_props, ["avatar", "classes", "className", "clickable", "component", "deleteIcon", "label", "onClick", "onDelete", "onKeyDown", "tabIndex"]);
	      var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.clickable, onClick || clickable), (0, _defineProperty2.default)({}, classes.deletable, onDelete), classNameProp);
	      var deleteIcon = null;
	
	      if (onDelete) {
	        deleteIcon = deleteIconProp && _react.default.isValidElement(deleteIconProp) ? _react.default.cloneElement(deleteIconProp, {
	          className: (0, _classnames.default)(deleteIconProp.props.className, classes.deleteIcon),
	          onClick: this.handleDeleteIconClick
	        }) : _react.default.createElement(_Cancel.default, {
	          className: classes.deleteIcon,
	          onClick: this.handleDeleteIconClick
	        });
	      }
	
	      var avatar = null;
	
	      if (avatarProp && _react.default.isValidElement(avatarProp)) {
	        avatar = _react.default.cloneElement(avatarProp, {
	          className: (0, _classnames.default)(classes.avatar, avatarProp.props.className),
	          childrenClassName: (0, _classnames.default)(classes.avatarChildren, avatarProp.props.childrenClassName)
	        });
	      }
	
	      var tabIndex = tabIndexProp;
	
	      if (!tabIndex) {
	        tabIndex = onClick || onDelete || clickable ? 0 : -1;
	      }
	
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        role: "button",
	        className: className,
	        tabIndex: tabIndex,
	        onClick: onClick,
	        onKeyDown: this.handleKeyDown,
	        ref: function ref(node) {
	          _this2.chipRef = node;
	        }
	      }, other), avatar, _react.default.createElement("span", {
	        className: classes.label
	      }, label), deleteIcon);
	    }
	  }]);
	  return Chip;
	}(_react.default.Component);
	
	Chip.propTypes =  false ? {
	  /**
	   * Avatar element.
	   */
	  avatar: _propTypes.default.element,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If true, the chip will appear clickable, and will raise when pressed,
	   * even if the onClick property is not defined. This can be used, for example,
	   * along with the component property to indicate an anchor Chip is clickable.
	   */
	  clickable: _propTypes.default.bool,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Override the default delete icon element. Shown only if `onDelete` is set.
	   */
	  deleteIcon: _propTypes.default.element,
	
	  /**
	   * The content of the label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback function fired when the delete icon is clicked.
	   * If set, the delete icon will be shown.
	   */
	  onDelete: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	} : {};
	Chip.defaultProps = {
	  clickable: false,
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiChip'
	})(Chip);
	
	exports.default = _default;

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	
	var _Chip = _interopRequireDefault(__webpack_require__(123));

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(30));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(27));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Transition = _interopRequireDefault(__webpack_require__(60));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var _transitions = __webpack_require__(111);
	
	var _utils = __webpack_require__(131);
	
	// @inheritedComponent Transition
	var styles = function styles(theme) {
	  return {
	    container: {
	      height: 0,
	      overflow: 'hidden',
	      transition: theme.transitions.create('height')
	    },
	    entered: {
	      height: 'auto'
	    },
	    wrapper: {
	      // Hack to get children with a negative margin to not falsify the height computation.
	      display: 'flex'
	    },
	    wrapperInner: {
	      width: '100%'
	    }
	  };
	};
	/**
	 * The Collapse transition is used by the
	 * [Vertical Stepper](/demos/steppers#vertical-stepper) StepContent component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	exports.styles = styles;
	
	var Collapse =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Collapse, _React$Component);
	
	  function Collapse() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Collapse);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call.apply(_ref, [this].concat(args))), _this.wrapper = null, _this.autoTransitionDuration = undefined, _this.timer = null, _this.handleEnter = function (node) {
	      node.style.height = _this.props.collapsedHeight;
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.handleEntering = function (node) {
	      var _this$props = _this.props,
	          timeout = _this$props.timeout,
	          theme = _this$props.theme;
	      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	
	      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      }),
	          transitionDuration = _getTransitionProps.duration;
	
	      if (timeout === 'auto') {
	        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	        node.style.transitionDuration = "".concat(duration2, "ms");
	        _this.autoTransitionDuration = duration2;
	      } else {
	        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	      }
	
	      node.style.height = "".concat(wrapperHeight, "px");
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.handleEntered = function (node) {
	      node.style.height = 'auto';
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node);
	      }
	    }, _this.handleExit = function (node) {
	      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	      node.style.height = "".concat(wrapperHeight, "px");
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.handleExiting = function (node) {
	      var _this$props2 = _this.props,
	          timeout = _this$props2.timeout,
	          theme = _this$props2.theme;
	      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	
	      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      }),
	          transitionDuration = _getTransitionProps2.duration;
	
	      if (timeout === 'auto') {
	        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	        node.style.transitionDuration = "".concat(duration2, "ms");
	        _this.autoTransitionDuration = duration2;
	      } else {
	        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	      }
	
	      node.style.height = _this.props.collapsedHeight;
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    }, _this.addEndListener = function (_, next) {
	      if (_this.props.timeout === 'auto') {
	        _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
	      }
	    }, _temp));
	  }
	
	  (0, _createClass2.default)(Collapse, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          collapsedHeight = _props.collapsedHeight,
	          Component = _props.component,
	          onEnter = _props.onEnter,
	          onEntered = _props.onEntered,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          onExiting = _props.onExiting,
	          style = _props.style,
	          theme = _props.theme,
	          timeout = _props.timeout,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "collapsedHeight", "component", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "theme", "timeout"]);
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        onEnter: this.handleEnter,
	        onEntered: this.handleEntered,
	        onEntering: this.handleEntering,
	        onExit: this.handleExit,
	        onExiting: this.handleExiting,
	        addEndListener: this.addEndListener,
	        timeout: timeout === 'auto' ? null : timeout
	      }, other), function (state, childProps) {
	        return _react.default.createElement(Component, (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)({}, classes.entered, state === 'entered'), className),
	          style: (0, _objectSpread2.default)({}, style, {
	            minHeight: collapsedHeight
	          })
	        }, childProps), _react.default.createElement("div", {
	          className: classes.wrapper,
	          ref: function ref(node) {
	            _this2.wrapper = node;
	          }
	        }, _react.default.createElement("div", {
	          className: classes.wrapperInner
	        }, children)));
	      });
	    }
	  }]);
	  return Collapse;
	}(_react.default.Component);
	
	Collapse.propTypes =  false ? {
	  /**
	   * The content node to be collapsed.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The height of the container when collapsed.
	   */
	  collapsedHeight: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])])
	} : {};
	Collapse.defaultProps = {
	  collapsedHeight: '0px',
	  component: 'div',
	  timeout: _transitions.duration.standard
	};
	Collapse.muiSupportAuto = true;
	
	var _default = (0, _withStyles.default)(styles, {
	  withTheme: true,
	  name: 'MuiCollapse'
	})(Collapse);
	
	exports.default = _default;

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	
	var _Collapse = _interopRequireDefault(__webpack_require__(216));

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(27));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(28));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(30));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(217));
	
	var _Paper = _interopRequireDefault(__webpack_require__(92));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var _reactHelpers = __webpack_require__(112);
	
	// @inheritedComponent Paper
	// Workaround https://github.com/jsdom/jsdom/issues/2026
	var edgeFix = typeof window !== 'undefined' && /jsdom/.test(window.navigator.userAgent) ? {} : {
	  // Fix a rendering issue on Edge
	  '@supports (-ms-ime-align: auto)': {
	    borderBottomLeftRadius: 0,
	    borderBottomRightRadius: 0
	  }
	};
	
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    root: {
	      position: 'relative',
	      transition: theme.transitions.create(['margin'], transition),
	      '&:before': {
	        position: 'absolute',
	        left: 0,
	        top: -1,
	        right: 0,
	        height: 1,
	        content: '""',
	        opacity: 1,
	        backgroundColor: theme.palette.divider,
	        transition: theme.transitions.create(['opacity', 'background-color'], transition)
	      },
	      '&:first-child': {
	        borderTopLeftRadius: 2,
	        borderTopRightRadius: 2,
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&:last-child': (0, _objectSpread2.default)({
	        borderBottomLeftRadius: 2,
	        borderBottomRightRadius: 2
	      }, edgeFix),
	      '&$expanded + &': {
	        '&:before': {
	          display: 'none'
	        }
	      }
	    },
	    expanded: {
	      margin: "".concat(theme.spacing.unit * 2, "px 0"),
	      '&:first-child': {
	        marginTop: 0
	      },
	      '&:last-child': {
	        marginBottom: 0
	      },
	      '&:before': {
	        opacity: 0
	      }
	    },
	    disabled: {
	      backgroundColor: theme.palette.action.disabledBackground
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ExpansionPanel =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ExpansionPanel, _React$Component);
	
	  function ExpansionPanel(props) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, ExpansionPanel);
	    _this = (0, _possibleConstructorReturn2.default)(this, (ExpansionPanel.__proto__ || Object.getPrototypeOf(ExpansionPanel)).call(this, props));
	    _this.state = {};
	    _this.isControlled = null;
	
	    _this.handleChange = function (event) {
	      var expanded = _this.isControlled ? _this.props.expanded : _this.state.expanded;
	
	      if (!_this.isControlled) {
	        _this.setState({
	          expanded: !expanded
	        });
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event, !expanded);
	      }
	    };
	
	    _this.isControlled = props.expanded != null;
	
	    if (!_this.isControlled) {
	      // not controlled, use internal state
	      _this.state.expanded = props.defaultExpanded !== undefined ? props.defaultExpanded : false;
	    }
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(ExpansionPanel, [{
	    key: "render",
	    value: function render() {
	      var _classNames,
	          _this2 = this;
	
	      var _props = this.props,
	          childrenProp = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          CollapsePropsProp = _props.CollapseProps,
	          defaultExpanded = _props.defaultExpanded,
	          disabled = _props.disabled,
	          expandedProp = _props.expanded,
	          onChange = _props.onChange,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "CollapseProps", "defaultExpanded", "disabled", "expanded", "onChange"]);
	      var expanded = this.isControlled ? expandedProp : this.state.expanded;
	      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);
	      var summary = null;
	
	      var children = _react.default.Children.map(childrenProp, function (child) {
	        if (!_react.default.isValidElement(child)) {
	          return null;
	        }
	
	        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
	          summary = _react.default.cloneElement(child, {
	            disabled: disabled,
	            expanded: expanded,
	            onChange: _this2.handleChange
	          });
	          return null;
	        }
	
	        return child;
	      });
	
	      var CollapseProps = !expanded ? {
	        'aria-hidden': 'true'
	      } : null;
	      return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	        className: className,
	        elevation: 1,
	        square: true
	      }, other), summary, _react.default.createElement(_Collapse.default, (0, _extends2.default)({
	        "in": expanded,
	        timeout: "auto"
	      }, CollapseProps, CollapsePropsProp), children));
	    }
	  }]);
	  return ExpansionPanel;
	}(_react.default.Component);
	
	ExpansionPanel.propTypes =  false ? {
	  /**
	   * The content of the expansion panel.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Properties applied to the `Collapse` element.
	   */
	  CollapseProps: _propTypes.default.object,
	
	  /**
	   * If `true`, expands the panel by default.
	   */
	  defaultExpanded: _propTypes.default.bool,
	
	  /**
	   * If `true`, the panel will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, expands the panel, otherwise collapse it.
	   * Setting this prop enables control over the panel.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the expand/collapse state is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {boolean} expanded The `expanded` state of the panel
	   */
	  onChange: _propTypes.default.func
	} : {};
	ExpansionPanel.defaultProps = {
	  defaultExpanded: false,
	  disabled: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanel'
	})(ExpansionPanel);
	
	exports.default = _default;

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	
	var _ExpansionPanel = _interopRequireDefault(__webpack_require__(218));

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 3, "px ").concat(theme.spacing.unit * 3, "px")
	    }
	  };
	};
	
	exports.styles = styles;
	
	function ExpansionPanelDetails(props) {
	  var classes = props.classes,
	      children = props.children,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), children);
	}
	
	ExpansionPanelDetails.propTypes =  false ? {
	  /**
	   * The content of the expansion panel details.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelDetails'
	})(ExpansionPanelDetails);
	
	exports.default = _default;

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	
	var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(220));

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(27));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(79));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(225));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    root: {
	      display: 'flex',
	      minHeight: theme.spacing.unit * 6,
	      transition: theme.transitions.create(['min-height', 'background-color'], transition),
	      padding: "0 ".concat(theme.spacing.unit * 3, "px 0 ").concat(theme.spacing.unit * 3, "px"),
	      '&:hover:not($disabled)': {
	        cursor: 'pointer'
	      },
	      '&$expanded': {
	        minHeight: 64
	      },
	      '&$focused': {
	        backgroundColor: theme.palette.grey[300]
	      },
	      '&$disabled': {
	        opacity: 0.38
	      }
	    },
	    expanded: {},
	    focused: {},
	    disabled: {},
	    content: {
	      display: 'flex',
	      flexGrow: 1,
	      transition: theme.transitions.create(['margin'], transition),
	      margin: '12px 0',
	      '& > :last-child': {
	        paddingRight: theme.spacing.unit * 4
	      },
	      '&$expanded': {
	        margin: '20px 0'
	      }
	    },
	    expandIcon: {
	      position: 'absolute',
	      top: '50%',
	      right: theme.spacing.unit,
	      transform: 'translateY(-50%) rotate(0deg)',
	      transition: theme.transitions.create('transform', transition),
	      '&:hover': {
	        // Disable the hover effect for the IconButton,
	        // because a hover effect should apply to the entire Expand button and
	        // not only to the IconButton.
	        backgroundColor: 'transparent'
	      },
	      '&$expanded': {
	        transform: 'translateY(-50%) rotate(180deg)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ExpansionPanelSummary =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ExpansionPanelSummary, _React$Component);
	
	  function ExpansionPanelSummary() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, ExpansionPanelSummary);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ExpansionPanelSummary.__proto__ || Object.getPrototypeOf(ExpansionPanelSummary)).call.apply(_ref, [this].concat(args))), _this.state = {
	      focused: false
	    }, _this.handleFocus = function () {
	      _this.setState({
	        focused: true
	      });
	    }, _this.handleBlur = function () {
	      _this.setState({
	        focused: false
	      });
	    }, _this.handleChange = function (event) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          onClick = _this$props.onClick;
	
	      if (onChange) {
	        onChange(event);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    }, _temp));
	  }
	
	  (0, _createClass2.default)(ExpansionPanelSummary, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          disabled = _props.disabled,
	          expanded = _props.expanded,
	          expandIcon = _props.expandIcon,
	          onChange = _props.onChange,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "disabled", "expanded", "expandIcon", "onChange"]);
	      var focused = this.state.focused;
	      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	        focusRipple: false,
	        disableRipple: true,
	        disabled: disabled,
	        component: "div",
	        "aria-expanded": expanded,
	        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.focused, focused), _classNames), className)
	      }, other, {
	        onFocusVisible: this.handleFocus,
	        onBlur: this.handleBlur,
	        onClick: this.handleChange
	      }), _react.default.createElement("div", {
	        className: (0, _classnames.default)(classes.content, (0, _defineProperty2.default)({}, classes.expanded, expanded))
	      }, children), expandIcon && _react.default.createElement(_IconButton.default, {
	        disabled: disabled,
	        className: (0, _classnames.default)(classes.expandIcon, (0, _defineProperty2.default)({}, classes.expanded, expanded)),
	        component: "div",
	        tabIndex: -1,
	        "aria-hidden": "true"
	      }, expandIcon));
	    }
	  }]);
	  return ExpansionPanelSummary;
	}(_react.default.Component);
	
	ExpansionPanelSummary.propTypes =  false ? {
	  /**
	   * The content of the expansion panel summary.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * If `true`, the summary will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * If `true`, expands the summary, otherwise collapse it.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * The icon to display as the expand indicator.
	   */
	  expandIcon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func
	} : {};
	ExpansionPanelSummary.defaultProps = {
	  disabled: false
	};
	ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelSummary'
	})(ExpansionPanelSummary);
	
	exports.default = _default;

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	
	var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(222));

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var _colorManipulator = __webpack_require__(94);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(79));
	
	var _helpers = __webpack_require__(80);
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  return {
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      width: 48,
	      height: 48,
	      padding: 0,
	      borderRadius: '50%',
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	    colorInherit: {
	      color: 'inherit'
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    disabled: {},
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/style/icons) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	
	function IconButton(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      disabled = props.disabled,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
	    centerRipple: true,
	    focusRipple: true,
	    disabled: disabled
	  }, other), _react.default.createElement("span", {
	    className: classes.label
	  }, children));
	}
	
	IconButton.propTypes =  false ? {
	  /**
	   * The icon element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple will be disabled.
	   */
	  disableRipple: _propTypes.default.bool
	} : {};
	IconButton.defaultProps = {
	  color: 'default',
	  disabled: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(224));

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _pure = _interopRequireDefault(__webpack_require__(44));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(93));
	
	var _ref = _react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var Cancel = function Cancel(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	Cancel = (0, _pure.default)(Cancel);
	Cancel.muiName = 'SvgIcon';
	var _default = Cancel;
	exports.default = _default;

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _styles2 = __webpack_require__(238);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EndPiece = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      published = props.published,
	      author = props.author;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.contents },
	    _react2.default.createElement(
	      'div',
	      { className: classes.endpiece },
	      _react2.default.createElement(
	        _Grid2.default,
	        { container: true, spacing: 40 },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 12 },
	          author.name && _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'caption', className: classes.author },
	            '\xA9 ',
	            author.name.text
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'caption', gutterBottom: true, className: classes.date },
	            published
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(EndPiece);
	module.exports = exports['default'];

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  return {
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    endpiece: {
	      fontSize: theme.typography.subheading.fontSize,
	      background: 'rgba(255,255,255,1)',
	      padding: '2rem 7rem 0 7rem',
	      maxWidth: 1024
	      // borderBottomLeftRadius: 25,
	      // borderBottomRightRadius: 25
	    },
	    author: {
	      fontWeight: theme.typography.fontWeightMedium,
	      color: theme.typography.body1.color
	    },
	    date: {
	      marginBottom: theme.spacing.unit * 3
	    }
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(133);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _ExpansionPanel = __webpack_require__(219);
	
	var _ExpansionPanel2 = _interopRequireDefault(_ExpansionPanel);
	
	var _ExpansionPanelSummary = __webpack_require__(223);
	
	var _ExpansionPanelSummary2 = _interopRequireDefault(_ExpansionPanelSummary);
	
	var _ExpansionPanelDetails = __webpack_require__(221);
	
	var _ExpansionPanelDetails2 = _interopRequireDefault(_ExpansionPanelDetails);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextField = __webpack_require__(127);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _styles = __webpack_require__(11);
	
	var _reactToastify = __webpack_require__(158);
	
	__webpack_require__(147);
	
	var _feedback = __webpack_require__(1416);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _constants = __webpack_require__(51);
	
	var _styles2 = __webpack_require__(584);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Feedback = function (_React$Component) {
	  _inherits(Feedback, _React$Component);
	
	  function Feedback() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Feedback);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      formdata: {
	        name: '',
	        email: '',
	        msg: ''
	      }
	    }, _this.onChange = function (e) {
	      var formdata = _this.state.formdata;
	      formdata[e.target.id] = e.target.value;
	      _this.setState({ formdata: formdata });
	    }, _this.submitForm = function (post) {
	      var formdata = _this.state.formdata;
	
	      _axios2.default.post(_constants.API.enquiry, {
	        mtype: 'Feedback',
	        template: 'feedback',
	        name: formdata.name,
	        email: formdata.email,
	        msg: formdata.msg,
	        item: post
	      }).then(function (response) {
	        _reactToastify.toast.success('Your feedback has been sent, thanks.');
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Feedback.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        classes = _props.classes,
	        post = _props.post;
	    var formdata = this.state.formdata;
	
	    return _react2.default.createElement(
	      'div',
	      { className: classes.feedback },
	      _react2.default.createElement(_reactToastify.ToastContainer, null),
	      _react2.default.createElement(
	        'div',
	        { className: classes.contents },
	        _react2.default.createElement(
	          _ExpansionPanel2.default,
	          null,
	          _react2.default.createElement(
	            _ExpansionPanelSummary2.default,
	            { expandIcon: _react2.default.createElement(FeedbackIcon, null) },
	            _react2.default.createElement(
	              _Grid2.default,
	              { container: true, spacing: 40 },
	              _react2.default.createElement(
	                _Grid2.default,
	                { item: true, xs: 12 },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { variant: 'subheading' },
	                  'Get in touch'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _ExpansionPanelDetails2.default,
	            null,
	            _react2.default.createElement(
	              'form',
	              { noValidate: true, autoComplete: 'off' },
	              _react2.default.createElement('input', { name: 'uid', type: 'hidden', value: post.uid }),
	              _react2.default.createElement(_TextField2.default, {
	                id: 'name',
	                label: 'Name',
	                margin: 'normal',
	                value: formdata.name,
	                onChange: function onChange(e) {
	                  return _this2.onChange(e);
	                }
	              }),
	              _react2.default.createElement(_TextField2.default, {
	                id: 'email',
	                label: 'Email',
	                margin: 'normal',
	                value: formdata.email,
	                fullWidth: true,
	                onChange: function onChange(e) {
	                  return _this2.onChange(e);
	                }
	              }),
	              _react2.default.createElement(_TextField2.default, {
	                id: 'msg',
	                label: 'Comment',
	                fullWidth: true,
	                margin: 'normal',
	                rows: 5,
	                multiline: true,
	                value: formdata.msg,
	                onChange: function onChange(e) {
	                  return _this2.onChange(e);
	                }
	              }),
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  size: 'small',
	                  variant: 'raised',
	                  className: classes.feedbackFormSubmit,
	                  onClick: function onClick() {
	                    return _this2.submitForm(post.uid);
	                  }
	                },
	                'Post form'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Feedback;
	}(_react2.default.Component);
	
	var FeedbackIcon = function FeedbackIcon() {
	  return _react2.default.createElement('img', { src: _feedback2.default });
	};
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Feedback);
	module.exports = exports['default'];

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  return {
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    feedback: {
	      marginTop: theme.spacing.unit * 5,
	      marginBottom: theme.spacing.unit * 5
	    },
	    feedbackFormSubmit: {
	      marginTop: theme.spacing.unit * 5
	    }
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Chip = __webpack_require__(124);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _share = __webpack_require__(251);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _styles2 = __webpack_require__(242);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lead = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      title = props.title,
	      published = props.published,
	      author = props.author,
	      suptitle = props.suptitle,
	      lead = props.lead,
	      tags = props.tags,
	      _props$hideSocial = props.hideSocial,
	      hideSocial = _props$hideSocial === undefined ? false : _props$hideSocial;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.contents },
	    _react2.default.createElement(
	      'div',
	      { className: classes.lead },
	      _react2.default.createElement(
	        _Grid2.default,
	        { container: true, spacing: 40 },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 12 },
	          tags && tags.map(function (tag, index) {
	            return _react2.default.createElement(_Chip2.default, { key: index, label: tag, className: classes.tag });
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { container: true, spacing: 40 },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 12 },
	          !hideSocial && _react2.default.createElement(
	            'div',
	            { className: classes.share },
	            _react2.default.createElement(_share2.default, {
	              shareUrl: typeof document !== 'undefined' && document.location.href,
	              title: title
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'inline', maxWidth: '100%' } },
	            suptitle && _react2.default.createElement(
	              _Typography2.default,
	              { className: classes.suptitle, gutterBottom: true },
	              suptitle.text
	            ),
	            _react2.default.createElement(
	              _Typography2.default,
	              { className: classes.head, gutterBottom: true },
	              title.text
	            ),
	            author && author.name && _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'caption', className: classes.author },
	              author.name.text
	            ),
	            _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'caption', gutterBottom: true },
	              published
	            )
	          ),
	          lead && lead.text && _react2.default.createElement(
	            _Typography2.default,
	            { className: classes.text },
	            lead.text
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Lead);
	module.exports = exports['default'];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  var _lead, _head;
	
	  return {
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    lead: (_lead = {
	      fontSize: theme.typography.subheading.fontSize,
	      background: 'rgba(255,255,255,1)',
	      padding: '7rem 7rem 0 7rem',
	      maxWidth: 1024
	    }, _lead[theme.breakpoints.down('sm')] = {
	      padding: '2rem 2rem 0 2rem'
	    }, _lead),
	    suptitle: {
	      textTransform: 'uppercase',
	      fontSize: theme.typography.caption.fontSize
	      // fontWeight: 800,
	    },
	    head: (_head = {
	      display: 'flex',
	      fontSize: theme.typography.display1.fontSize,
	      fontWeight: 800,
	      lineHeight: .9,
	      textTransform: 'uppercase'
	    }, _head[theme.breakpoints.down('sm')] = {
	      fontSize: theme.typography.headline.fontSize,
	      wordBreak: 'break-word'
	    }, _head),
	    share: {
	      float: 'right'
	    },
	
	    author: {
	      fontWeight: theme.typography.fontWeightMedium,
	      color: theme.typography.body1.color
	    },
	    text: {
	      marginTop: theme.spacing.unit * 2
	    },
	    tag: {
	      marginRight: theme.spacing.unit,
	      marginBottom: theme.spacing.unit
	    }
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlayer = __webpack_require__(89);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styles = __webpack_require__(11);
	
	var _styles2 = __webpack_require__(245);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Poster = function (_React$Component) {
	  _inherits(Poster, _React$Component);
	
	  function Poster() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Poster);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      isIOS: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Poster.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent)
	    });
	  };
	
	  Poster.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        classes = _props.classes,
	        image = _props.image,
	        urls = _props.urls,
	        poster = _props.poster;
	    var isIOS = this.state.isIOS;
	
	
	    return !isIOS && urls ? _react2.default.createElement(_reactPlayer2.default, {
	      ref: function ref(p) {
	        return _this2.player = p;
	      },
	      url: urls[0].src,
	      width: '100%',
	      height: '100%',
	      loop: true,
	      autoPlay: true,
	      playing: true,
	      muted: true
	    }) : image.src !== {} ? _react2.default.createElement('img', { src: image.src, className: classes.poster, alt: image.alt }) : _react2.default.createElement('div', { className: classes.poster });
	  };
	
	  return Poster;
	}(_react2.default.Component);
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Poster);
	module.exports = exports['default'];

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var styles = function styles(theme) {
	  var _poster;
	
	  return {
	    poster: (_poster = {
	      height: '100%',
	      width: '100%',
	      minHeight: '100vh',
	      backgroundImage: 'linear-gradient(to right top, #212a2a, #094153, #2d4f84, #864e98, #d6407d)',
	      textAlign: 'left',
	      display: 'flex',
	      alignItems: 'center'
	    }, _poster[theme.breakpoints.down('sm')] = {
	      height: '30%',
	      minHeight: '30vh'
	    }, _poster)
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gradient = __webpack_require__(83);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _styles2 = __webpack_require__(250);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderImage = function renderImage(props) {
	  var classes = props.classes,
	      section = props.section;
	
	
	  return section && section.image && section.image.src && section.image.src.length > 0 && _react2.default.createElement('img', {
	    src: section.image.src,
	    alt: section.image.alt,
	    className: classes.sectionImage
	  });
	};
	
	var Section = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      section = props.section;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.contents },
	    _react2.default.createElement(
	      'div',
	      { className: classes.section },
	      _react2.default.createElement(
	        _Grid2.default,
	        { container: true, spacing: 40 },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 12 },
	          renderImage(props),
	          section && section.contents && section.contents.map(function (content, index) {
	            return _react2.default.createElement(SectionContent, { key: index, content: content, classes: classes });
	          })
	        )
	      )
	    )
	  );
	});
	
	var SectionContent = function SectionContent(_ref) {
	  var content = _ref.content,
	      classes = _ref.classes;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    content.title && _react2.default.createElement(
	      _Typography2.default,
	      { gutterBottom: true, variant: 'title' },
	      content.title.text
	    ),
	    content.subtitle && _react2.default.createElement(
	      _Typography2.default,
	      { gutterBottom: true, variant: 'subheading' },
	      content.subtitle.text
	    ),
	    content.text && _react2.default.createElement('div', {
	      dangerouslySetInnerHTML: { __html: content.text && content.text.html },
	      className: classes.text
	    })
	  );
	};
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Section);
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  var _section;
	
	  return {
	
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    section: (_section = {
	      background: 'rgba(255,255,255,1)',
	      padding: '3rem 7rem',
	      maxWidth: 1024
	    }, _section[theme.breakpoints.down('sm')] = {
	      padding: '2rem 2rem'
	    }, _section),
	    sectionImage: {
	      width: '100%',
	      maxWidth: 1024,
	      marginBottom: theme.spacing.unit * 4
	    },
	    text: _extends({}, (0, _mixins.RichText)(theme))
	
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _inline = __webpack_require__(139);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _styles2 = __webpack_require__(166);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoSlice = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      video = props.video;
	
	  var obj = { src: video.video.url_dash.url };
	  var data = [];
	  data.push(obj);
	  data.push(obj);
	  var poster = video.video.poster;
	  poster.src = video.video.poster.url;
	  return _react2.default.createElement(
	    'div',
	    { className: classes.contents },
	    _react2.default.createElement(
	      'div',
	      { className: classes.section },
	      _react2.default.createElement(
	        'div',
	        { className: classes.videospacing },
	        video.title && _react2.default.createElement(
	          _Typography2.default,
	          { gutterBottom: true, variant: 'title' },
	          video.title.text
	        ),
	        video.subtitle && _react2.default.createElement(
	          _Typography2.default,
	          { gutterBottom: true, variant: 'subheading' },
	          video.subtitle.text
	        ),
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true, spacing: 40 },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 12 },
	            _react2.default.createElement(_inline2.default, { urls: data, poster: poster })
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(VideoSlice);
	module.exports = exports['default'];

/***/ }),

/***/ 1416:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _fragments = __webpack_require__(46);
	
	var _mapper = __webpack_require__(38);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _poster = __webpack_require__(244);
	
	var _poster2 = _interopRequireDefault(_poster);
	
	var _lead = __webpack_require__(241);
	
	var _lead2 = _interopRequireDefault(_lead);
	
	var _quote = __webpack_require__(68);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _section = __webpack_require__(249);
	
	var _section2 = _interopRequireDefault(_section);
	
	var _slice = __webpack_require__(615);
	
	var _slice2 = _interopRequireDefault(_slice);
	
	var _endpiece = __webpack_require__(237);
	
	var _endpiece2 = _interopRequireDefault(_endpiece);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _feedback = __webpack_require__(583);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _constants = __webpack_require__(51);
	
	var _site = __webpack_require__(43);
	
	var _site2 = _interopRequireDefault(_site);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Post = function Post(props) {
	  var classes = props.classes;
	
	  var metadata = (0, _mapper.mapMetaData)(props.data.post);
	  var post = (0, _mapper.mapPost)(props.data.post);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_metadata2.default, { data: metadata }),
	    _react2.default.createElement(_poster2.default, { image: post.image, urls: post.video_bg.urls, poster: post.video_bg.poster }),
	    _react2.default.createElement(
	      'div',
	      { className: classes.mainFloat },
	      _react2.default.createElement(_lead2.default, {
	        title: post.title,
	        author: post.author,
	        published: post.published,
	        lead: post.lead,
	        path: props.location.pathname,
	        tags: post.tags
	      }),
	      post.contents && post.contents.map(function (content, index) {
	        switch (content.type) {
	          case _constants.CONTENTTYPES.section:
	            return _react2.default.createElement(_section2.default, { key: index, section: content });
	          case _constants.CONTENTTYPES.quote:
	            return _react2.default.createElement(_quote2.default, { key: index, quote: content });
	          case _constants.CONTENTTYPES.video:
	            return _react2.default.createElement(_slice2.default, { key: index, video: content });
	        }
	      }),
	      _react2.default.createElement(_endpiece2.default, { author: post.author, published: post.published }),
	      _react2.default.createElement(_feedback2.default, { post: post })
	    ),
	    _react2.default.createElement(_footer2.default, { policies: props.data.policies.edges })
	  );
	};
	
	exports.default = (0, _styles.withStyles)(_site2.default)(Post);
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-5733cffb31a4cd02b642.js